import {
  BooleanInput,
  NumberInput,
  SimpleForm,
  minValue,
  required,
  useCreate,
  useNotify,
  useRedirect,
} from 'react-admin'
import { Grid } from '@mui/material'
import { CreateBase } from '../../components/base'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { BranchSelectInput, FormBottomToolbarWithPermission } from '../../components/form'
import { ServiceMultiSelectInput } from '../../components/form/ServiceMultiSelectInput'
import { useCallback } from 'react'
import { TimeStepInput } from '../../components/domains/branch-config/TimeStepInput'
import { closeTime, openTime, validateOpenSlot } from '../../utils/validators'

const PREFIX = 'resources.branchconfig.fields'

const BranchConfigCreate = (): JSX.Element => {
  const notify = useNotify()
  const redirect = useRedirect()
  const onError = useCallback(
    (error): void => {
      const errorMessage = error.response.data.message
      return notify(errorMessage || 'ra.validation.create_branch_config_fail', { type: 'error' })
    },
    [notify],
  )
  const onSuccess = useCallback(async (): Promise<void> => {
    notify('ra.notification.create_branch_config_success', { type: 'success' })
    redirect('list', 'branch_config')
  }, [notify, redirect])
  const [create] = useCreate(undefined, undefined, { onError, onSuccess })

  const handleSubmit = (data): void => {
    create('branch_config', { data })
  }

  return (
    <CreateBase
      title={'resources.branchconfig.create.title'}
      listAction={{
        hasBackButton: true,
      }}
    >
      <SimpleForm onSubmit={handleSubmit} toolbar={<FormBottomToolbarWithPermission />} sx={{}}>
        <Grid container spacing={1} justifyContent='center'>
          <Grid container item spacing={3} xs={12} md={8}>
            <Grid item xs={12} md={6}>
              <NumberInput
                source='slot'
                label={`${PREFIX}.slot`}
                validate={[required(), minValue(1)]}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <NumberInput
                source='open_slot'
                label={`${PREFIX}.open_slot`}
                validate={[required(), minValue(1), validateOpenSlot]}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TimeStepInput source='open_time' validate={[required(), openTime]} />
            </Grid>
            <Grid item xs={12}>
              <TimeStepInput source='close_time' validate={[required(), closeTime]} />
            </Grid>
            <Grid item xs={12}>
              <BranchSelectInput source='branch_code' validate={[required()]} excludeConfigured />
            </Grid>
            <Grid item xs={12}>
              <ServiceMultiSelectInput source='service_key' validate={[required()]} />
            </Grid>
            <Grid item>
              <BooleanInput
                color='primary'
                source='is_active'
                label={`${COMMON_FIELDS}.status.label`}
                defaultValue={true}
              />
            </Grid>
          </Grid>
        </Grid>
      </SimpleForm>
    </CreateBase>
  )
}
export default BranchConfigCreate
